import React, { useEffect, useState } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { getCustomRedirect } from 'services/auth';
import { Basic, Blank, RouteWithLayout } from './layouts';
import * as Pages from './pages';

export default function Routes() {
  const [customUrls, setCustomUrls] = useState();
  useEffect(() => {
    getCustomRedirect().then((customUrl) => {
      setCustomUrls(customUrl);
    });
  }, []);

  return (
    <Switch>
      <Redirect exact from="/" to="/auth/login" />
      <Redirect exact from="/help" to="/help/notice/list" />
      <RouteWithLayout
        name="URL Redirection"
        menuId="urlRedirectAfterUpdating"
        component={Pages.ClientUpdateCheckInURLRedirection}
        exact
        layout={Blank}
        path="/url-redirect/updating"
      />
      <RouteWithLayout
        name="URL Redirection"
        menuId="urlRedirect"
        component={Pages.urlRedirect}
        exact
        layout={Blank}
        path="/url-redirect"
      />
      <RouteWithLayout
        name="Login"
        menuId="login"
        component={Pages.Login}
        exact
        layout={Blank}
        path="/auth/login"
      />
      <RouteWithLayout
        name="사용자 등록"
        menuId="register"
        component={Pages.Register}
        exact
        layout={Blank}
        path="/auth/register"
      />
      <RouteWithLayout
        name="비밀번호 재설정"
        menuId="resetPassword"
        component={Pages.ResetPassword}
        exact
        layout={Blank}
        path="/resetPassword/:token"
      />
      <RouteWithLayout
        name="필수 프로그램 확인"
        menuId="requiredApps"
        component={Pages.RequiredApps}
        exact
        layout={Blank}
        path="/auth/requiredApps"
      />
      <RouteWithLayout
        name="Desktops"
        menuId="desktops"
        component={Pages.Desktops}
        exact
        layout={Basic}
        path="/desktops"
      />
      <RouteWithLayout
        name="파일 다운로드"
        menuId="transfer"
        component={Pages.Transfer}
        exact
        layout={Basic}
        componentProps={{ href: customUrls?.fileDownLoad }}
        path="/transfer"
      />
      <RouteWithLayout
        name="서비스 신청"
        menuId="request"
        component={Pages.Request}
        exact
        layout={Basic}
        path="/request"
      />
      {/* <RouteWithLayout
        name="승인 업무"
        key='approval'
        component={Pages.Approval}
        exact
        layout={Basic}
        path="/approval"
      /> */}
      {/* <RouteWithLayout
        name="Help Center"
        key='help'
        component={Pages.Help}
        exact
        layout={Basic}
        path="/help"
      /> */}
      <RouteWithLayout
        name="공지사항"
        menuId="notice"
        component={Pages.NoticeList}
        exact
        layout={Basic}
        path="/help/notice/list"
      />
      <RouteWithLayout
        name="공지사항"
        menuId="notice"
        component={Pages.NoticeView}
        exact
        layout={Basic}
        path="/help/notice/view"
      />
      <RouteWithLayout
        name="FAQ"
        menuId="faq"
        component={Pages.Faq}
        exact
        layout={Basic}
        path="/help/faq"
      />
      <RouteWithLayout
        name="다운로드"
        menuId="download"
        component={Pages.Download}
        exact
        layout={Basic}
        path="/help/download"
      />
      <RouteWithLayout
        name="내 정보"
        menuId="myInfo"
        component={Pages.MyInfo}
        exact
        layout={Basic}
        path="/myInfo"
      />
      <RouteWithLayout
        name="사용 현황"
        menuId="usage"
        component={Pages.Usage}
        exact
        layout={Basic}
        path="/myInfo/usage"
      />
      <RouteWithLayout
        name="Error"
        menuId="error"
        component={Pages.Error}
        exact
        layout={Blank}
        path="/error"
      />
    </Switch>
  );
}
